import type { Example } from "@h2lca/core";
import { Button } from "@/components/ui/FormControls";
import { useMaster } from "@/store/master";
import { MethodBadge } from "./Badges";

/** 예시 시나리오 카드 , 예시 화면과 (시나리오가 하나도 없을 때) 시나리오 화면이 같은 것을 쓴다 */
export function ExampleCards({ onStart }: { onStart: (ex: Example) => void }) {
  const data = useMaster((s) => s.data);
  const examples = data.examples.filter((e) => e.active).sort((a, b) => a.order - b.order);
  return (
    <ul className="grid grid-cols-1 gap-content md:grid-cols-2 xl:grid-cols-3">
      {examples.map((ex) => {
        const tech = data.technologies.find((t) => t.id === ex.scenario.basis.productionTechId);
        return (
          <li key={ex.id} className="start-card">
            <div className="flex items-start justify-between gap-item">
              <h3 className="text-body font-bold text-ink">{ex.name}</h3>
              <MethodBadge method={ex.scenario.method} />
            </div>
            <p className="text-caption leading-relaxed text-ink-muted">{ex.description}</p>
            <div className="flex flex-wrap gap-label">
              {tech && <span className="start-tag">{tech.name}</span>}
              {ex.tags.map((t) => (
                <span key={t} className="start-tag">
                  {t}
                </span>
              ))}
            </div>
            <div className="mt-auto flex items-center justify-between gap-item pt-label">
              <span className="text-footnote text-ink-subtle">{ex.reference ? "기준결과값 제공" : "기준결과값은 전문가 검산 후 제공"}</span>
              <Button variant="soft" onClick={() => onStart(ex)}>
                이 예시로 시작
              </Button>
            </div>
          </li>
        );
      })}
    </ul>
  );
}
